import React, { useEffect, useState } from 'react';
import './styles/blogs.css';
import axios from 'axios';


const Blog = (props)=>{
    return(
        <div id={"projId"+props.record.blogNumber} className='blog'>
            <div className='blogHead'>
                {props.record.blogNumber}
            </div>
            <div className='blogBody'>
                <p><span>{props.record.blogTime}</span>
                    {props.record.blogDesc}
                </p>
            </div>
        </div>
    )
}

export default function Blogs(){

    const [Projs,setProjs] = useState({"records": []});

    useEffect(()=>{
        axios
            .get("https://myportfolioapp-server.herokuapp.com/blogs/")
            .then((res)=>{
                setProjs({"records": res.data});
            })
            .catch((err)=>{
                console.log(err);
            });
    });


    return(
        <div className='blogs'>
            {
                Projs["records"].map((key,i)=>{
                    return(
                        <Blog key={i} record={key}/>
                    )
                })
            }
        </div>
    );
}